import classNames from 'classnames';
import { Page } from 'components/atoms';
import React, { FC } from 'react';
import styles from "../Subpage.module.css";

type TSimplifiedBannerMobileProps = {
    HeroSectionTitle: string;
    HeroSectionSuperscript: string;
}

export const SimplifiedBannerMobile: FC<TSimplifiedBannerMobileProps> = ({
    HeroSectionSuperscript,
    HeroSectionTitle
}) => {
    return (
        <Page className="pb-0 pt-0">
            <div className={classNames(styles.simplifiedBannerWrapper, 'col-12')}
                style={{ paddingTop: '72px' }}>
                 <h1 className="mb-0">
                    <span dangerouslySetInnerHTML={{ __html: HeroSectionSuperscript }} />
                    <em dangerouslySetInnerHTML={{ __html: HeroSectionTitle }} />
                </h1>
            </div>
        </Page>
    )
}
